import { resolve, dirname } from "path";
import { fileURLToPath } from "url";
import run from "clio-run/src/runners/auto.js";
const __dirname = dirname(fileURLToPath(import.meta.url));
const config = {
  "servers": [
    {
      "proto": "ww",
      "name": "default"
    }
  ],
  "workers": [
    {
      "proto": "ww",
      "count": "cpu",
      "server": "default"
    }
  ],
  "executor": {
    "proto": "ww",
    "wait_for": "cpu",
    "server": "default"
  }
};
run(resolve(__dirname, "../main.clio.js"), config);